import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import useFetch from 'utils/hooks/useFetch';
import { ApiCheckAuth, ApiGetUserMenuAccess } from 'utils/constants/api';
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, ModalTypeFail } from 'utils/Constant';
import { ModalProvider, useModal } from 'components/modal/ModalContext';
// import Cookies from 'js-cookie'

export default function MainContainer({ children }) {
	const { fetch: checkAuth } = useFetch(ApiCheckAuth)
	const { fetch: getUserMenuAccess } = useFetch(ApiGetUserMenuAccess)
	
	let pathName = window.location.pathname
	let pathArray = pathName.split("/")

	const [isSidebarOpen, setIsSidebarOpen] = useState(localStorage.getItem("SidebarState") === "open" ? true : false);
	
	useEffect(() => {
		if (pathArray[1] !== "login"){
			if (localStorage.getItem("Token") ===  null){
				window.location.href = "/login"
			}
			fCheckAuth()
			// fGetUserMenuAccess()
		}

		
		//fGetUserMenuAccess()
	}, [])

	if (pathArray[1] === "login"){
		return(
			<div className="overflow-hidden">
				<div className="">{ children }</div>
			</div>
		)
	}

	// Function Call API
	async function fCheckAuth(){
		await checkAuth({
			data: {}
		}).then((response) => {
			if(response.status === ApiResponseStatusUnauthorized){
				window.location.href = "/login"
			}
		})
	}
	async function fGetUserMenuAccess(){
		await getUserMenuAccess({
			data: {
				userId: localStorage.getItem("Id"),
				companyId: localStorage.getItem("CompanyId")
			}
		}).then((response) => {
			if(response.status === ApiResponseSuccess){

			}else if(response.status === ApiResponseStatusUnauthorized){
				window.location.href = "/login"
			}
		})
	}

	function fToggleSidebar(state){
		if (state){
			localStorage.setItem("SidebarState", "close")
		}else{
			localStorage.setItem("SidebarState", "open")
		}

		setIsSidebarOpen(!state)
	}

	function fOnMobileToggleSidebar(){
		if (window.innerWidth < 720) {
			fToggleSidebar(isSidebarOpen)
		}
	}

	return (
		<ModalProvider>
			<div className="overflow-hidden h-screen w-full flex flex-col bg-black">
				<div className="sm:hidden sticky top-0 left-0 bottom-0 z-30 shadow-md">
					<Navbar toggleSidebar={() => { fToggleSidebar(isSidebarOpen) }} />
				</div>
				<div className='w-full h-screen overflow-hidden flex bg-white'>
					<div className='sticky top-0 z-30'>
						<Sidebar isOpen={isSidebarOpen} onSidebarClick={() => { fOnMobileToggleSidebar() }} />
					</div>
					<div className='w-full overflow-auto bg-white sm:bg-slate-50'>
						{ children }
					</div>
				</div>
			</div>
		</ModalProvider>
		
	)
}
